var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "53",
        height: "43",
        viewBox: "0 0 153 143",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M16.9 116.8L25.2 102.4C28.7 96.3 35.2 92.6 42.2 92.6H62.6H74C73 89.6 71.6 86.6 69.7 83.8C59 67.5 37.2 62.2 20.2 71.5C1.4 81.8 -5 105.8 6.2 124.1C16.3 140.7 37.9 146.9 55.3 138.1C64.5 133.5 70.8 125.7 73.9 116.8H16.9V116.8Z",
          fill: "url(#paint0_linear)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M136.1 116.8H119.5C112.5 116.8 106 113.1 102.5 107L92.3 89.4L86.6 79.6C84.5 82 82.6 84.7 81.1 87.8C72.4 105.2 78.6 126.7 95.3 136.8C113.7 147.9 137.6 141.5 147.9 122.6C157.2 105.5 151.8 83.7 135.5 73.1C126.9 67.5 116.9 65.9 107.7 67.7L136.1 116.8Z",
          fill: "url(#paint1_linear)"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M76.5 13.5L84.8 27.9C88.3 34 88.3 41.4 84.8 47.5L74.6 65.1L68.9 74.9C72 75.5 75.3 75.8 78.7 75.6C98.1 74.5 113.7 58.3 114.1 38.8C114.6 17.3 97 -0.199995 75.5 0.300005C56 0.800005 39.9 16.4 38.8 35.8C38.2 46.1 41.8 55.5 48 62.6L76.5 13.5Z",
          fill: "url(#paint2_linear)"
        }
      }),
      _vm._v(" "),
      _c(
        "defs",
        [
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint0_linear",
                x1: "1.0764",
                y1: "121.775",
                x2: "69.3381",
                y2: "89.9444",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#017C91" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.2159", "stop-color": "#03788E" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.4396", "stop-color": "#076B84" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.6669", "stop-color": "#0F5774" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.8953", "stop-color": "#1A3A5D" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#202A51" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint1_linear",
                x1: "149.258",
                y1: "128.56",
                x2: "87.5607",
                y2: "85.3594",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", {
                attrs: { offset: "0.000251257", "stop-color": "#AE638E" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.2495", "stop-color": "#AA638F" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.5077", "stop-color": "#9D6490" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.7691", "stop-color": "#896593" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#706697" } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "paint2_linear",
                x1: "80.1333",
                y1: "-3.60659",
                x2: "73.5689",
                y2: "71.4252",
                gradientUnits: "userSpaceOnUse"
              }
            },
            [
              _c("stop", { attrs: { "stop-color": "#B3D1BD" } }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.1493", "stop-color": "#AFD0BC" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.304", "stop-color": "#A2CDB8" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.4613", "stop-color": "#8EC9B2" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.6204", "stop-color": "#71C3AA" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.7808", "stop-color": "#4BBB9F" }
              }),
              _vm._v(" "),
              _c("stop", {
                attrs: { offset: "0.9402", "stop-color": "#1EB192" }
              }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-color": "#0BAD8D" } })
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }